import { IconButton, Link, ListItemIcon, Menu, MenuItem, Toolbar, Typography, AppBar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormatListNumberedRtl, Help, LocalCafe } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import React, { FC } from 'react';
import smallLogo from '../assets/img/fm-logo-sm-icon.png';
import AppNavigation from '../Routes/AppNavigation';
import { Link as RouterLink } from 'react-router-dom';

const Root = styled('div')({
  flexGrow: 1,
  paddingTop: '56px'
});

const Title = styled(Typography)({
  flexGrow: 1,
});

const MenuIconStyled = styled(ListItemIcon)({
  verticalAlign: 'middle',
  minWidth: '24px',
});

const Logo = styled('img')({
  verticalAlign: 'middle',
});

const StyledRouterLink = styled(RouterLink)({
  width: '100%',
});

const StyledLink = styled(Link)({
  width: '100%',
});

const RootLayout: FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Root>
        <AppBar position="fixed">
          <Toolbar>
            <IconButton
              aria-controls="nav-menu"
              aria-haspopup="true"
              onClick={handleClick}
              edge="start"
              color="inherit"
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
            <Menu id="nav-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
              <MenuItem component={StyledRouterLink} color="textPrimary" to="/" onClick={handleClose}>
                <MenuIconStyled>
                  <FormatListNumberedRtl fontSize="small" />
                </MenuIconStyled>{' '}
                Token Tracker
              </MenuItem>
              <MenuItem component={StyledRouterLink} style={{ width: '100%' }} color="textPrimary" to="/help" onClick={handleClose}>
                <MenuIconStyled>
                  <Help fontSize="small" />
                </MenuIconStyled>{' '}
                Help
              </MenuItem>
              <MenuItem
                component={StyledLink}
                onClick={handleClose}
                color="textPrimary"
                href="https://www.buymeacoffee.com/frenziedmarmot"
                target="_blank"
                rel="noreferrer"
              >
                <MenuIconStyled>
                  <LocalCafe fontSize="small" />
                </MenuIconStyled>{' '}
                Buy me a coffee
              </MenuItem>
            </Menu>
            <Title variant="h6">
              Token Tracker
            </Title>
            <a href="https://frenziedmarmot.com" target="_blank" rel="noreferrer">
              <Logo src={smallLogo} alt="Frenzied Marmot logo" />
            </a>
          </Toolbar>
        </AppBar>
      </Root>
      <AppNavigation />
    </>
  );
};

export default RootLayout;
